import React, { useEffect, useState } from 'react';
import { getExecutiveEditors } from '../services/firebaseService';
import { FaBriefcase, FaMapMarkerAlt, FaGraduationCap, FaEnvelope, FaPhone } from 'react-icons/fa';

function ExecutiveEditorsList({ editors }) {
  const [internalEditors, setInternalEditors] = useState([]);

  useEffect(() => {
    if (editors === undefined || editors === null) {
      getExecutiveEditors().then(setInternalEditors);
    }
    // Only fetch once on mount if no prop is provided
    // eslint-disable-next-line
  }, []);

  // Use editors prop only if it is a non-empty array, otherwise fallback to internalEditors
  const editorsToRender = (Array.isArray(editors) && editors.length > 0) ? editors : internalEditors;
  console.log('editors prop:', editors);
  console.log('internalEditors (from Firestore):', internalEditors);
  console.log('editorsToRender (used for rendering):', editorsToRender);

  // Only filter out editors with no name
  const realEditors = (editorsToRender || []).filter(
    editor => editor.name && editor.name.trim() !== ''
  );
  realEditors.forEach(editor => {
    if (!editor.img || editor.img.includes('placeholder.com')) {
      console.warn('Editor is using a placeholder or missing image:', editor.name);
    }
  });
  console.log('realEditors (after filtering):', realEditors);
  console.log('realEditors.length:', realEditors.length);
  console.log('Will render editors:', realEditors.length > 0);
  
  console.log('ExecutiveEditorsList: About to render with', realEditors.length, 'editors');
  


  // Define the desired order for designations
  const DESIGNATION_ORDER = [
    'Editor-in-Chief',
    'Managing Editor',
    'Executive Editor',
    'Executive Editorial Board',
    'Associate Editor',
    'Section Editor',
    'Reviewer',
    'Proof Reader',
    'Legal Advisor',
  ];

  // Group editors by designation
  const groupedEditors = DESIGNATION_ORDER.map(designation => ({
    designation,
    editors: (realEditors || []).filter(e => (e.designation || e.title) === designation)
  })).filter(group => group.editors.length > 0);

  return (
    <div className="container mx-auto p-4 max-w-5xl">
      {groupedEditors.length === 0 ? (
        <div className="text-center text-gray-500">No executive editors found.</div>
      ) : (
        groupedEditors.map(group => (
          <div key={group.designation} className="mb-8">
            <h2 className="text-2xl font-bold text-accent mb-4 border-b pb-1">{group.designation}</h2>
            {group.editors.map((editor, idx) => (
              <div key={editor.name} className="flex items-start gap-6 mb-6">
                <img
                  src={editor.img || '/assets/img/default-doctor.svg'}
                  alt={editor.name}
                  onError={e => {
                    if (!e.target.src.includes('default-doctor.svg')) {
                      e.target.onerror = null;
                      e.target.src = '/assets/img/default-doctor.svg';
                    }
                  }}
                  className="w-24 h-24 rounded-full object-cover border border-gray-200"
                />
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-heading mb-1">{editor.name}</h4>
                  {(editor.memberDesignation || editor.designationTitle) && (
                    <div className="text-sm text-gray-800 mb-1 ml-2 flex items-start gap-2">
                      <FaBriefcase className="text-[#03478E] text-xs flex-shrink-0 mt-1" />
                      <span className="font-medium text-gray-800 leading-snug">
                        {editor.memberDesignation || editor.designationTitle}
                      </span>
                    </div>
                  )}
                  {editor.qualification && (
                    <div className="text-sm text-gray-600 mb-1 ml-2 flex items-start gap-2">
                      <FaGraduationCap className="text-accent text-xs flex-shrink-0 mt-1" />
                      <span className="leading-snug">{editor.qualification}</span>
                    </div>
                  )}
                  {(editor.address || editor.institution) && (
                    <div className="text-sm text-gray-600 mb-1 ml-2 flex items-start gap-2">
                      <FaMapMarkerAlt className="text-red-500 text-xs flex-shrink-0 mt-1" />
                      <span className="leading-relaxed">{editor.address || editor.institution}</span>
                    </div>
                  )}
                  {editor.email && (
                    <div className="text-sm text-gray-600 mb-1 ml-2 italic flex items-center gap-2">
                      <FaEnvelope className="text-accent text-xs flex-shrink-0" />
                      <span>{editor.email}</span>
                    </div>
                  )}
                  {editor.contactNumber && (
                    <div className="text-sm text-gray-600 mb-1 ml-2 italic flex items-center gap-2">
                      <FaPhone className="text-accent text-xs flex-shrink-0" />
                      <span>{editor.contactNumber}</span>
                    </div>
                  )}
                  <p className="text-gray-600 mb-3 ml-2 text-sm">{editor.desc}</p>
                  {Array.isArray(editor.social) && editor.social.length > 0 && (
                    <div className="flex gap-3 mt-2">
                      {editor.social.map((s, index) => (
                        s.icon ? (
                          <a key={s.icon || index} href={s.url} target="_blank" rel="noopener noreferrer" className="text-accent hover:text-heading transition-colors duration-200 text-xl bg-gray-100 rounded-full p-2">
                            <i className={s.icon}></i>
                          </a>
                        ) : null
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}

export default ExecutiveEditorsList;


